import { AxiosError } from 'axios';
import instance from '../config/axios';
import { BulkEmailConfig } from '../interface/interface';

export async function validateEmailFilterData(
  token: string,
  payload: BulkEmailConfig,
) {
  try {
    const response = await instance({
      method: 'POST',
      url: `/api/v1/validate/email/filter`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { emailPayload: payload },
    });

    return response.data.message;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response!.status;
  }
}
